import React, { useState } from 'react'
import { Dialog, Button } from '@material-ui/core'
import OpcionAutodescargable from './OpcionAutodescargable'
import { connect } from 'react-redux'
import { updateCamionAcopladoEjes } from '../actions'
import { COLORES } from '../../../config/colores'

function EdicionAutodescargable (props) {
  const { cea, actualizarData = null, colorAutodescargable = null, updateCamionAcopladoEjes } = props
  const [open, setOpen] = useState(false)

  const handleOpen = () => { setOpen(true) }
  const handleClose = () => { setOpen(false) }

  const handleSubmit = (autodescargable) => {
    updateCamionAcopladoEjes(autodescargable, cea.camion, cea.acoplado, actualizarData)
    handleClose()
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth='xs'
      >
        <OpcionAutodescargable initial={cea.autodescargable} handleSubmit={handleSubmit} />

      </Dialog>
      <Button onClick={handleOpen}>
        {cea.autodescargable ? <b style={{ color: colorAutodescargable || COLORES.blue.primary }}>Si</b> : <>No</> }
      </Button>
    </>
  )
}

const mapActionsToProps = {
  updateCamionAcopladoEjes
}

const widthRedux = connect(null, mapActionsToProps)
export default widthRedux(EdicionAutodescargable)
